import { Component, input, output } from '@angular/core';
import { CardUIType, PlaylistCardShort } from '@app/app/shared/models';

@Component({
  selector: 'ptl-card-item-main-view',
  templateUrl: './card-item-main-view.component.html',
  styleUrls: ['./card-item-main-view.component.scss'],
})
export class CardItemMainViewComponent {
  card = input<PlaylistCardShort>();
  cardIndex = input<number>(0);
  cardType = input<CardUIType>('general');
  showImage = input(true);
  showMeta = input(true);
  showReviews = input(true);

  cardClick = output<PlaylistCardShort>();
}
